import {
  grayDark,
  purpleLight,
  redLight,
  yellowLight,
} from '@crehana/ui/dist/styles/colors';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

export const Root = styled.div`
  position: relative;
  .recharts-responsive-container {
    width: 120% !important;
    margin-left: -55px;
    @media (min-width: 400px) {
      width: 115% !important;
    }
    @media (min-width: 500px) {
      width: 110% !important;
    }
    ${({ theme }) => theme.breakpoints.up('sm')} {
      width: 100% !important;
      margin-left: -28px;
    }
  }
  .scatter-container {
    top: 0;
    left: 0;
    position: absolute;
  }
  .recharts-layer {
    tspan {
      font-family: Poppins;
      font-size: 24px;
      font-weight: bold;
      fill: white;
    }
    tspan:last-child {
      font-family: Nunito;
      font-size: 11px;
      fill: ${grayDark};
    }
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    .recharts-responsive-container {
      margin-left: 12px;
    }
  }
`;

export const Levels = styled.div`
  ${({ theme }) => theme.breakpoints.up('md')} {
    top: 7px;
    left: -3px;
    z-index: 1;
    .advance-level {
      height: 38px;
      border-right: 1px solid ${purpleLight};
    }
    .intermediate-level {
      height: 56px;
      border-right: 1px solid ${yellowLight};
    }
    .beginner-level {
      height: 104px;
      border-right: 1px solid ${redLight};
    }
  }
`;

export const LevelsMobile = styled.div`
  width: 85%;
  margin: 0 auto;
`;
